/* eslint-disable jira/filename-case */
import { getMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import { getSsrResourceTimeout } from '@atlassian/jira-common-performance/src/ssrResourceTimeout.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const getState = () => {
	// @ts-expect-error -- __SSR_FALLBACK__ is set by static fallback. not in global typings.
	if (globalThis.__SSR_FALLBACK__) {
		return 'static-fallback';
	}
	if (getMark('ssr.spa.state')?.startTime) {
		return 'success';
	}
	if (getMark('ssr.spa.early-common-flush:end')?.startTime) {
		return 'spa-render-failure';
	}

	return 'static-fallback';
};

export const getSSRStateInformation = (): {
	'ssr:state': string;
	'ssr:resourceTimeout'?: number;
} => {
	return {
		'ssr:state': getState(),
		...(fg('nin_ssr_resource_timeout_info') && {
			'ssr:resourceTimeout': getSsrResourceTimeout(),
		}),
	};
};
